<script setup>
import { Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

defineProps({ vehicle: { type: Object, required: true } })

const { t } = useI18n()

function statusLabel(status) {
  const key = `supplier_portal.status.${status}`
  return t(key, status)
}
</script>

<template>
  <Link :href="`/vehicles/${vehicle.id}`" class="card">
    <div class="card__photo">
      <img v-if="vehicle.photo_url" :src="vehicle.photo_url" :alt="`${vehicle.make} ${vehicle.model}`" loading="lazy" />
      <div v-else class="card__placeholder">{{ vehicle.make?.[0] }}{{ vehicle.model?.[0] }}</div>
    </div>
    <div class="card__body">
      <h3 class="card__title">{{ vehicle.make }} {{ vehicle.model }}</h3>
      <p class="card__status"><span :class="['pill', `pill--${vehicle.status}`]">{{ statusLabel(vehicle.status) }}</span></p>
      <p v-if="vehicle.rental_window" class="card__window">
        {{ vehicle.rental_window.from }} → {{ vehicle.rental_window.to }}
      </p>
      <p v-if="vehicle.balance" class="card__balance">{{ t('supplier_portal.vehicle.cols.balance') }} <span class="fw-value">{{ vehicle.balance }}</span></p>
    </div>
  </Link>
</template>

<style scoped>
.card { display: block; text-decoration: none; color: inherit; background: var(--surface); border: 1px solid var(--line); border-radius: 0.75rem; overflow: hidden; }
.card:hover { border-color: var(--accent); }
.card__photo { aspect-ratio: 4 / 3; background: var(--surfaceAlt); display: grid; place-items: center; overflow: hidden; }
.card__photo img { width: 100%; height: 100%; object-fit: cover; }
.card__placeholder { font-size: 2rem; font-weight: 700; color: var(--muted); }
.card__body { padding: 0.75rem 1rem 0.875rem; }
.card__title { font-size: 1rem; margin: 0 0 0.4rem; color: var(--ink); font-weight: 600; }
.card__status { margin: 0 0 0.4rem; }
.card__window  { font-size: 0.8125rem; color: var(--inkSoft); margin: 0 0 0.2rem; }
.card__balance { font-size: 0.875rem; color: var(--ink); margin: 0; }
.pill { display: inline-block; padding: 0.15rem 0.5rem; border-radius: 999px; font-size: 0.75rem; }
.pill--available { background: color-mix(in oklch, var(--ok) 16%, var(--surface)); color: var(--ok); }
.pill--active    { background: color-mix(in oklch, var(--accent) 16%, var(--surface)); color: var(--accent); }
.pill--pending   { background: color-mix(in oklch, var(--warn) 14%, var(--surface)); color: var(--warn); }
.pill--off_fleet { background: color-mix(in oklch, var(--muted) 14%, var(--surface)); color: var(--muted); }
</style>
